import React from 'react';
//import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Switch,
  Button
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import Profile from './Profile';
import InputIcon from '@material-ui/icons/Input';
import SettingsIcon from '@material-ui/icons/Settings';
import auth from '../../../auth/auth';
import history from '../../../auth/history';
import { Dashboards } from '../../../common/Constants';

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none'
  },
  appBarShift: {
    marginLeft: 240,
    width: `calc(100% - ${240}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  flexGrow: {
    flexGrow: 1
  },
  iconButton: {
    marginLeft: theme.spacing(1)
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  hide: {
    display: 'none'
  },
  title: {
    marginLeft: theme.spacing(1),
    color: 'primary'
  }
}));

const Topbar = props => {
  const {
    className,
    open,
    onSidebarOpen,
    showFraudEngines,
    showAMLEngines,
    setShowAMLEngines,
    setShowFraudEngines,
    brandingInfo,
    ...rest
  } = props;
  const [menu, setMenu] = React.useState(null);
  const classes = useStyles();
  const handleMenuOpen = event => {
    setMenu(event.currentTarget);
  };
  const handleClose = () => {
    setMenu(null);
  };
  const avatar = JSON.parse(localStorage.getItem('User'));

  const handleShowFraudEngines = event => {
    setShowFraudEngines(event.target.checked === true ? true : false);
    localStorage.setItem('Fraud', event.target.checked === true ? true : false);
    if (event.target.checked === true && showAMLEngines === false) {
      history.replace('/solution/' + Dashboards[1]);
    }
    if (event.target.checked === false) {
      history.replace('/solution/' + Dashboards[0]);
    }
  };
  const handleShowAMLEngines = event => {
    setShowAMLEngines(event.target.checked === true ? true : false);
    localStorage.setItem('Aml', event.target.checked === true ? true : false);

    if (event.target.checked === true) {
      history.replace('/solution/' + Dashboards[0]);
    }
    if (event.target.checked === false && showFraudEngines === true) {
      history.replace('/solution/' + Dashboards[1]);
    }
  };

  const { logourl, logoheight, primaryColor, secondaryColor } = 
  brandingInfo.logourl !== undefined
  ? brandingInfo
  : {
      logourl:
        "https://dist.neo4j.com/wp-content/uploads/20210422140034/Neo4j-logo_color.png",
      logoheight: 36,
      primaryColor: "#FFFFFF",
      secondaryColor: "#000000"
    };  
  const navBarStyle = (primaryColor) ? { background: primaryColor, borderBottom: '3px solid #0080FA' } : {}
  const textStyle = (secondaryColor) ? { color: secondaryColor } : {}

  const Defaults = {
    LogoHeight: 30
  }
  
  // this is because the logoheight is sized for Hive, we need to adjust it for this demo
  const LogoHeightMultiplier = 30/36;
  
  const getLogoHeight = (logoheight) => {
    var returnVal = '';
    if (logoheight && typeof(logoheight) === 'number') {
      returnVal = Math.floor(LogoHeightMultiplier * logoheight);
    } else {
      returnVal = Defaults.LogoHeight
    }
    return `${returnVal}px`;
  }

  return (
    <AppBar
      {...rest}
      // color='secondary'
      style={navBarStyle}
      className={clsx(classes.root, className)}>
      <Toolbar>
        <IconButton
          aria-label="open drawer"
          onClick={onSidebarOpen}
          edge="start"
          className={clsx(classes.menuButton)}
          style={textStyle}
          >
          
          <MenuIcon />
        </IconButton>
        {/* <img alt="Logo" src="/images/neo4j_logo.png" width="40" /> */}
        {logourl &&
          <img src={logourl} alt="Branding Logo" height={getLogoHeight(logoheight)} style={{marginRight: '8px'}}></img>
        }

        {localStorage.getItem('Fraud') === 'true' &&
        localStorage.getItem('Aml') === 'true' ? (
          <Typography variant="h2" className={classes.title} style={textStyle}>
            Fraud & AML Framework
          </Typography>
        ) : localStorage.getItem('Fraud') === 'true' &&
          localStorage.getItem('Aml') === 'false' ? (
          <Typography variant="h2" className={classes.title} style={textStyle}>
            Fraud Framework
          </Typography>
        ) : localStorage.getItem('Aml') === 'true' &&
          localStorage.getItem('Fraud') === 'false' ? (
          <Typography variant="h2" className={classes.title} style={textStyle}>
            AML Framework
          </Typography>
        ) : (
          <Typography variant="h2" className={classes.title} style={textStyle}>
            AML Framework
          </Typography>
        )}

        <div className={classes.flexGrow} />
        <Typography variant="h4" className={classes.title} style={textStyle}>
          {avatar.name}{' '}
        </Typography>
        <Profile avatar={avatar} />
        {/* <IconButton
          aria-controls="simple-menu"
          className={classes.iconButton}
          style={textStyle}
          onClick={handleMenuOpen}>
          <SettingsIcon />
        </IconButton>
        <Menu
          id="simple-menu"
          anchorEl={menu}
          keepMounted
          open={Boolean(menu)}
          onClose={handleClose}>
          <MenuItem>
            <Switch
              checked={showAMLEngines === true ? true : false}
              onChange={handleShowAMLEngines}
              color="secondary"
              size="small"
              name="Aml"
            />
            AML
          </MenuItem>
          <MenuItem>
            <Switch
              checked={showFraudEngines === true ? true : false}
              color="secondary"
              name="Fraud"
              size="small"
              onChange={handleShowFraudEngines}
            />
            Fraud
          </MenuItem>
        </Menu> */}
        <IconButton
          className={classes.iconButton}
          style={textStyle}
          onClick={() => {
            localStorage.clear();
            auth.logout();
          }}>
          <InputIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string
};

export default Topbar;
